/**
 * Canonical Equipos afectados list: split on comma, semicolon, or whitespace.
 * `OLT-01, OLT-02` and `OLT-01,OLT-02` become `OLT-01,OLT-02`.
 * A space inside a name also separates: `OLT Paredes` becomes `OLT,Paredes`.
 */
export function normalizeEquiposAfectados(value) {
  if (value == null) return '';
  const cleaned = String(value).replace(/\r\n/g, '\n').trim();
  if (!cleaned || cleaned.toLowerCase() === 'undefined' || cleaned.toLowerCase() === 'null') {
    return '';
  }
  const items = cleaned
    .split(/[\s,;]+/)
    .map((item) => item.trim())
    .filter(Boolean);
  return items.join(',');
}
